import { toMoment } from 'api/helpers';
import OrderType from './OrderType';
import he from 'he';

export default class Item {
	name = '';
	db_item_name = '';
	number = '';
	base_number = '';
	list_price = 0;
	ta = 0;
	net_price = 0;
	promo_price = 0;
	est_ship_date = null;
	est_ship_date_for_cart = null;
	invoice_hold_weeks = 0;
	order_type = null;
	is_drop_ship = '';
	image_url = '';
	quantity_in_pack = 0;
	quantity = 0;
	end_date = null;
	is_configurable = false;
	promotion_name = '';
	promotion_id = 0;
	id = null;
	pack_id = null;
	is_preview = false;
	category_id = null;
	category_end_date = '';
	is_pack = false;
	is_preview = false;
	promotion_end_date = '';
	start_date = '';
	total_config_qty_ordered = 0;
	category_promotion_class_id = 0;
	quantity_available = 0;
	promo_no_of_days = null;
	pack_name = null;
	price_list = null;
	item_description = '';
	category_ship_type_id = 0;
	category_ship_type_name = '';

	constructor(item) {
		this.id = item.Id;
		this.pack_id = item.PackId;
		this.category_id = item.CategoryId;
		this.name = he.decode(item.Name);
		this.db_item_name = item.Name;
		this.number = item.Number;
		this.base_number = item.BaseNumber;
		this.list_price = item.ListPrice;
		this.promo_price = item.PromoPrice;
		this.ta = item.TA;
		this.net_price = item.NetPrice;
		this.est_ship_date = toMoment(item.EstShipDate);
		this.est_ship_date_for_cart = toMoment(item.EstShipDateForCart);
		this.invoice_hold_weeks = item.OrderType.HoldInvoiceWeeks;
		this.order_type = new OrderType(item.OrderType);
		this.is_drop_ship = item.IsDropShipAllowed;
		this.image_url = item.ImageUrl;
		this.quantity_in_pack = item.QuantityInPack;
		this.quantity = item.Quantity;
		this.category_name = item.CategoryName;
		this.end_date = toMoment(item.EndDate);
		this.is_configurable = item.IsConfigurable;
		this.is_preview = item.IsPreview;
		this.promotion_name = item.PromotionName;
		this.promotion_id = item.PromotionId;
		this.currency = {
			currency_symbol: item.CurrencySymbol,
			country_short_name: item.CountryShortName,
		};
		this.category_end_date = toMoment(item.CategoryEndDate);
		this.is_pack = item.IsPack;
		this.is_preview = item.IsPreview;
		this.promotion_end_date = toMoment(item.PromotionEndDate);
		this.start_date = toMoment(item.StartDate);
		this.offerings =
			this.is_pack &&
			item.Offerings.map(item => ({
				id: item.Id,
				promo_no_of_days: item.PromoNoOfDays,
				price_list: item.PriceList,
				price: item.Price,
				image_url: item.ImageUrl,
				name: he.decode(item.Name),
				db_item_name: item.Name,
				number: item.Number,
				base_number: item.BaseNumber,
				is_configurable: item.IsConfigurable,
				quantity: item.Quantity,
				invoice_hold_weeks: item.OrderType.HoldInvoiceWeeks,
				order_type: new OrderType(item.OrderType),
				net_price: item.NetPrice,
				est_ship_date: toMoment(item.EstShipDate),
				promo_price: item.PromoPrice,
				is_drop_ship_allowed: item.IsDropShipAllowed,
			}));
		this.total_config_qty_ordered = item.TotalConfigQtyOrdered;
		this.category_promotion_class_id = item.CategoryPromotionClassId;
		this.quantity_available = item.QuantityAvailable;
		this.promo_no_of_days = item.PromoNoOfDays;
		this.pack_name = item.IsPack ? item.PackName : null;
		this.price_list = item.PriceList;
		this.item_description = item.ItemDescription;
		this.category_ship_type_id = item.CategoryShipTypeId;
		this.category_ship_type_name = item.CategoryShipTypeName;
	}
}



// WEBPACK FOOTER //
// ./src/api/models/Item.js